import React from "react";
interface Props {
  title: string;
  name: string;
  actionCallback: () => void;
  plusComponent?: boolean;
  canClick?: boolean;
  disabled?: boolean;
}

const ButtonComponent: React.FC<Props> = ({
  title,
  name,
  actionCallback,
  plusComponent,
  canClick,
}) => {
  return (
    <div className={`${name}`} onClick={canClick == false ? undefined : actionCallback } >
      {plusComponent && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23"
          height="17.89"
          viewBox="0 0 27 21"
          fill="none"
        >
          <g clip-path="url(#clip0_3373_8043)">
            <path
              d="M0 11.733V10.9565C0.0977299 10.8156 0.10938 10.6247 0.181221 10.4585C0.355323 10.056 1.37534 9.01463 1.74684 8.72702C2.48532 8.15634 3.53705 8.13881 4.29429 8.69001L9.29599 13.7099L9.38855 13.7378L22.7691 0.350649C23.3057 -0.00902411 24.0577 -0.0992671 24.6661 0.11368C25.1619 0.287025 26.4602 1.54069 26.7198 2.00294C27.2226 2.89953 27.0142 3.80066 26.3774 4.54987C20.9136 9.96575 15.5559 15.5037 10.0319 20.8507C9.68238 21.0501 9.04164 21.0501 8.69214 20.8507C5.84503 18.1305 3.04387 15.3251 0.332023 12.4679L0 11.733Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_3373_8043">
              <rect width="27" height="21" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
      {title}
    </div>
  );
};

export default ButtonComponent;
